module.exports = __webpack_public_path__ + "img/yishi1.350369b9.jpg";